<template>
  <div id="app">
    <div class="container minWidth1440">
      <div class="shade" v-show="popToggle==true"></div>
      <div class="pop" v-show="popToggle==true">
        <div class="popBg">
          <p class="tel">请拨打：021-69517010</p>
        </div>
        <img @click="closePop()" class="close" src="../src/assets/images/close.png" alt />
        <div style="clear:both;"></div>
      </div>

      <div class="topBg">
        <div class="topMiddle">
          <div class="userState" v-if="loginState==false">
            <!-- loginState===true(已登录) false(未登陆) -->
            <router-link name="login" :to="{name:'login',params:{state:1}}" class="toLogin">
              <h1 class="loginOrUser login">{{loginOrUser}}</h1>
            </router-link>
            <span class="spans">/</span>

            <router-link name="register" :to="{name:'register',params:{state:2}}" class="toLogin">
              <h1 class="registerOrExit">{{registerOrExit}}</h1>
            </router-link>

            <div style="clear:both;"></div>
          </div>
          <div class="userState" v-else>
            <h1 class="loginOrUser">{{loginOrUser}}</h1>
            <span class="spans">/</span>
            <h1 class="registerOrExit" @click="exit()">{{registerOrExit}}</h1>

            <div style="clear:both;"></div>
          </div>

          <h1 class="topTit">小型柔性化智能制造产线虚拟仿真实验</h1>
        </div>
      </div>

      <div class="content">
        <!-- 路由占位符 -->
        <router-view />
      </div>

      <div class="bottom">
        <div class="bottomDiv">
          <div class="linksDiv">
            <p class="links">友情链接:</p>
            <a class="links linkLeft" target="_blank" href="https://www.jxust.edu.cn/">江西理工大学</a>
            <a class="links linkLeft" target="_blank" href="http://www.moe.gov.cn/">中华人民共和国教育部</a>
            <a class="links linkLeft" target="_blank" href="http://jyt.jiangxi.gov.cn/">江西省教育厅</a>
            <a class="links linkLeft" target="_blank" href="http://www.mol.space">摩尔空间</a>
            <div class="contact" @click="contactUs()">联系客服</div>
            <div style="clear:both;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      popToggle: false,
      loginState: false, // true(已登录) false(未登陆)
      loginOrUser: '登陆',
      registerOrExit: '注册'
    }
  },
  methods: {
    getRequest() {
      var url = location.search // 获取url中?后面的字符串
      // eslint-disable-next-line no-new-object
      var theRequest //  = new Object()
      if (url.indexOf('?') !== -1) {
        var str = url.substr(1)
        var strs = str.split('&')
        for (var i = 0; i < strs.length; i++) {
          theRequest = strs[i].split('=')[1]
        }
      }
      return theRequest
    },
    // 调用http://jiangxi.ilab-x.com的token
    initToken() {
      const tokens = this.getRequest()
      const that = this
      const paramObj = {
        xjwt: encodeURIComponent(tokens)
      }
      this.$server.getstatefromxlab(paramObj).then((res) => {
        if (res.code === 200 && res.success) {
          that.tool.setCookie('un', jQuery.parseJSON(res.content).un, 1)
          that.tool.setCookie('token', tokens, 1) // 储存cookie
          that.tool.setCookie('username', jQuery.parseJSON(res.content).dis, 1) // 储存用户名
          that.$router.replace('/index')
          that.loginInit() // 调用App.vue中的loginInit方法
        } else {
          that.$message({
            showClose: true,
            message: res.msg
          })
          that.exit() // token失效退出登陆
        }
      })
    },
    // 登陆初始化
    loginInit() {
      var that = this
      var ulog = that.tool.getCookie('username')
      // console.log(ulog)
      if (ulog) {
        that.loginState = true
        that.loginOrUser = ulog
        that.registerOrExit = '退出'
      } else {
        that.loginState = false
        that.loginOrUser = '登陆'
        that.registerOrExit = '注册'
      }
    },
    // 退出登陆
    exit() {
      this.tool.clearCookie('username')
      this.tool.clearCookie('un')
      this.tool.clearCookie('token')
      this.loginInit()
    },
    // 显示联系我们弹窗
    contactUs() {
      this.popToggle = true
    },
    // 关闭联系我们弹窗
    closePop() {
      this.popToggle = false
    },
    // 提示框-公用 that=>vue实例对象 message=> '提示文字' type(提示状态)=> 'success'||'warning'||'error'
    tips(that, message, type) {
      that.$message.success({
        showClose: true,
        message: message,
        type: type
      })
    },
    // 离开页面时触发
    closePage() {}
  },

  // 页面初始化方法
  mounted() {
    this.$nextTick(() => {
      this.loginInit()
    })
    this.initToken()
    window.onbeforeunload = this.closePage
  }
}
</script>

<style scoped>
@import '../src/assets/css/index.css';
</style>
